import request from '@/utils/request'

// 获取消息推送列表
export function getList(data) {
  return request.get('/projectConfig/list')
}

// 更新消息推送信息
export function updateOne(data) {
  return request.post('/projectConfig/update', data)
}

